import { ActionIcon, Group, NumberInput } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import React, { useMemo, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  decreaseQuantity,
  increaseQuantity,
} from "../../Actions/articleActions";
import { HiMinusSm, HiPlusSm } from "react-icons/hi";

const useStyles = createStyles({
  actionButton: {
    borderRadius: "50%",
    border: "none",
    "&:disabled": {
      color: "gray",
      backgroundColor: "transparent !important",
    },
  },
  actionWrapper: {
    backgroundColor: "#d6d6d6",
    padding: "0rem 0.3rem",
    borderRadius: "1.25rem",
    width: "fit-content",
  },
  hideLabel: {
    opacity: 0,
    position: "absolute",
    width: "0px",
    height: "0px",
  },
  quantityInput: {
    display: "flex",
    alignItems: "center",
    fontSize: "1.5rem",
  },
});
const QuantityInput = ({ item, language, quantity, saleId }) => {
  const { classes } = useStyles();
  const rdxDispatch = useDispatch();
  const quantityChangeRef = useRef();

  const announceQuantityChange = (newQuantity) => {
    quantityChangeRef.current.innerText = `${language.Cart_Quantity} ${newQuantity}`;
  };
  const increase = () => {
    announceQuantityChange(quantity + 1);
    rdxDispatch(increaseQuantity(saleId, item.key));
  };
  const decrease = () => {
    announceQuantityChange(quantity - 1);
    rdxDispatch(decreaseQuantity(saleId, item.key));
  };

  const inStock = useMemo(() => {
    if (typeof item?.article?.inStock === "number")
      return item?.article?.inStock;
    else return null;
  }, [item?.article]);

  return (
    <div>
      <div
        className={classes.hideLabel}
        role="region"
        aria-live="assertive"
        ref={quantityChangeRef}
      />
      <Group gap={5} className={classes.actionWrapper}>
        <ActionIcon
          className={`${classes.actionButton} addToCart primaryButton`}
          size={30}
          variant="filled"
          disabled={
            !item.canChangeQuantity || item?.extraInformation?.length > 0
          }
          onClick={() => decrease()}
          title={`${language.Cart_Decrease} ${item.article.name} ${language.Cart_Quantity}`}
          aria-label={`${language.Cart_Decrease} ${item.article.name} ${language.Cart_Quantity}`}
        >
          <div className={classes.quantityInput}>
            <HiMinusSm />
          </div>
        </ActionIcon>
        <NumberInput
          hideControls
          value={quantity}
          aria-label={`${language.Cart_Article} ${item.article.name} ${language.Cart_Quantity} ${quantity}`}
          max={0}
          min={1}
          step={1}
          tabIndex={-1}
          styles={{
            input: {
              backgroundColor: "transparent",
              border: "none",
              width: 30,
              textAlign: "center",
              height: 30,
              fontWeight: "600",
              fontSize: "1.25rem",
              padding: 0,
              pointerEvents: "none",
            },
          }}
          sx={{ input: { padding: "0 !important" } }}
        />
        <ActionIcon
          className={`${classes.actionButton} addToCart primaryButton`}
          size={30}
          variant="filled"
          disabled={
            !item.canChangeQuantity ||
            inStock === quantity ||
            item?.extraInformation?.length > 0
          }
          onClick={() => increase()}
          title={`${language.Cart_Increase} ${item.article.name} ${language.Cart_Quantity}`}
          aria-label={`${language.Cart_Increase} ${item.article.name} ${language.Cart_Quantity}`}
        >
          <div className={classes.quantityInput}>
            <HiPlusSm />
          </div>
        </ActionIcon>
      </Group>
    </div>
  );
};

export default QuantityInput;
